import { render, staticRenderFns } from "./Ccck.vue?vue&type=template&id=71edd478&scoped=true&"
import script from "./Ccck.vue?vue&type=script&lang=js&"
export * from "./Ccck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71edd478",
  null
  
)

export default component.exports